import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

type Ymd = "y" | "m" | "d";
type YmdCombination =
	| Ymd
	| `${Ymd}${Ymd}`
	| `${Ymd}${Ymd}${Ymd}`
	| "t"
	| "lastymd"
	| "firstymd"
	| "utcdatetime"
	| "localdatetime"
	| "localymd"
	| "localdate"
	| "localtime";

dayjs.extend(utc);

const getLastDayOfMonth = (_year: string, _month: string): string => {
	return new Date(Number(_year), Number(_month), 0)
		.getDate()
		.toString()
		.padStart(2, "0");
};

const getFormattedDate = (
	_date: Date | string,
	_type: YmdCombination,
): string => {
	let selectTime = "";
	let selectYear = "";
	let selectMonth = "";
	let selectDay = "";

	if (typeof _date === "string" || _date instanceof String) {
		const dateArr: string[] = _date.split("-");
		if (dateArr.length === 3) {
			const d = new Date(_date);
			selectTime = `${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;

			selectYear = dateArr[0];
			selectMonth = dateArr[1];
			selectDay = dateArr[2];
		} else {
			const dateToday = new Date();
			selectTime = `${dateToday.getHours().toString().padStart(2, "0")}:${dateToday.getMinutes().toString().padStart(2, "0")}`;

			selectYear = String(dateToday.getFullYear());
			selectMonth = (dateToday.getMonth() + 1).toString().padStart(2, "0");
			selectDay = String(dateToday.getDate()).padStart(2, "0");
		}
	} else {
		selectTime = `${_date.getHours().toString().padStart(2, "0")}:${_date.getMinutes().toString().padStart(2, "0")}`;

		selectYear = String(_date.getFullYear());
		selectMonth = (_date.getMonth() + 1).toString().padStart(2, "0");
		selectDay = String(_date.getDate()).padStart(2, "0");
	}

	switch (_type) {
		case "t":
			return selectTime;

		case "m":
			return selectMonth;

		case "y":
			return selectYear;

		case "d":
			return selectDay;

		case "ym":
			return `${selectYear}-${selectMonth}`;

		case "ymd":
			if (
				getFormattedDate(new Date(), "ym") === `${selectYear}-${selectMonth}`
			) {
				return `${selectYear}-${selectMonth}-${String(new Date().getDate()).padStart(2, "0")}`;
			}
			return `${selectYear}-${selectMonth}-${selectDay}`;

		case "firstymd":
			return `${selectYear}-${selectMonth}-01`;

		case "lastymd":
			return `${selectYear}-${selectMonth}-${getLastDayOfMonth(selectYear, selectMonth)}`;

		case "utcdatetime":
			return dayjs.utc(_date).format("YYYY-MM-DD HH:mm:ss");

		case "localdatetime": {
			let utcTime = dayjs.utc(_date, "HH:mm:ss");
			if (utcTime.toString() === "Invalid Date") {
				utcTime = dayjs.utc(
					`${selectYear}-${selectMonth}-${selectDay} ${_date}:00`,
					"HH:mm:ss",
				);
			}
			return utcTime.local().format("HH:mm");
		}

		case "localymd":
			return dayjs.utc(_date).local().format("YYYY-MM-DD");

		case "localdate":
			return dayjs.utc(_date).local().format("MMM D, YYYY");

		case "localtime":
			return dayjs.utc(_date).local().format("HH:mm");

		default:
			return "";
	}
};

export default getFormattedDate;
